import { render, staticRenderFns } from "./ListPromotions.vue?vue&type=template&id=7703e11e&scoped=true"
import script from "./ListPromotions.vue?vue&type=script&lang=js"
export * from "./ListPromotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7703e11e",
  null
  
)

export default component.exports